<script>

    import Event from './Event.svelte';

    export let events = [];

</script>

<ul>
    {#each events as event}
        <Event {event} />
    {/each}
</ul>

<style>

    ul {
        min-height: var(--list-min-height);
    }

</style>